import React, {
  PropsWithChildren,
  ReactNode,
  useCallback,
  useState,
} from 'react';

import DownCaret from 'components/icons/DownCaret';
import UpCaret from 'components/icons/UpCaret';
import {
  CollapsibleContainer,
  CollapsibleSummaryContainer,
  CollapsibleDetail,
  CollapsibleTitle,
  DetailContent,
} from './components';

type CollapsibleProps = {
  title: ReactNode;
  initOpen?: boolean;
  caretColor?: string;
  childrenSelected?: any;
  dataTestid?: string;
};

const CollapsibleOutlined = ({
  title,
  initOpen = false,
  children,
  caretColor,
  childrenSelected,
  dataTestid
}: PropsWithChildren<CollapsibleProps>) => {
  const [collapsed, setCollapsed] = useState(!initOpen);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((collapsed) => !collapsed);
  }, []);

  return (
    <>
      <CollapsibleContainer>
        <CollapsibleSummaryContainer>
          <CollapsibleTitle onClick={toggleCollapsed} data-testid={dataTestid}>
            {title}
            {collapsed ? (
              <DownCaret color={caretColor} />
            ) : (
              <UpCaret color={caretColor} />
            )}
          </CollapsibleTitle>
        </CollapsibleSummaryContainer>
        <CollapsibleDetail collapsed={collapsed}>
          <DetailContent collapsed={collapsed}>{children}</DetailContent>
        </CollapsibleDetail>
        {childrenSelected &&
          <CollapsibleDetail collapsed={!collapsed}>
            <DetailContent collapsed={!collapsed}>{childrenSelected}</DetailContent>
          </CollapsibleDetail>}
      </CollapsibleContainer>
    </>
  );
};

export default CollapsibleOutlined;
